import { render, staticRenderFns } from "./OrderPrintItem.vue?vue&type=template&id=042a83f6&scoped=true&"
import script from "./OrderPrintItem.vue?vue&type=script&lang=js&"
export * from "./OrderPrintItem.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/order/OrderPrintItem/OrderPrintItemStyle.css?vue&type=style&index=0&id=042a83f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042a83f6",
  null
  
)

export default component.exports